const StaffPublicKey = '-----BEGIN CERTIFICATE-----\n' +
    'MIIF1zCCA7+gAwIBAgIUZmttbIjK2/R7LguzGXr0wPWYA3swDQYJKoZIhvcNAQEL\n' +
    'BQAwezELMAkGA1UEBhMCUlUxDzANBgNVBAgMBk1vc2NvdzEPMA0GA1UEBwwGTW9z\n' +
    'Y293MQwwCgYDVQQKDANXT0cxDDAKBgNVBAsMA0RFVjEMMAoGA1UEAwwDV09HMSAw\n' +
    'HgYJKoZIhvcNAQkBFhFzdXBwb3J0QHdvZy5nYW1lczAeFw0yMTEwMTMxMDUxNDVa\n' +
    'Fw0yMTExMTIxMDUxNDVaMHsxCzAJBgNVBAYTAlJVMQ8wDQYDVQQIDAZNb3Njb3cx\n' +
    'DzANBgNVBAcMBk1vc2NvdzEMMAoGA1UECgwDV09HMQwwCgYDVQQLDANERVYxDDAK\n' +
    'BgNVBAMMA1dPRzEgMB4GCSqGSIb3DQEJARYRc3VwcG9ydEB3b2cuZ2FtZXMwggIi\n' +
    'MA0GCSqGSIb3DQEBAQUAA4ICDwAwggIKAoICAQCmzKSKLHKEegCiAlkq/kmBY+ZU\n' +
    'B6tj6NVnbeR7RfEiEhEtKRfw44g9bMn+BU8qscbqngDrpzgapHZQH/MEqqImiaWz\n' +
    'kDO5b4y8x63TGt12WdY+YFG9xQOMOPZ9WyOdcsfiwqI9AboqpyYPfi2SklOfKlPv\n' +
    '0w6lvZ1p5HOBpul0Ujb/WOWry5Fgq1FcJLV9rKeRMaYG9tqSUV8ipjQIWv8RtPAW\n' +
    'YHYPrtJQTPJO1e0i9mKK1EZvjQbGE809A9pVTNRj4odK0Lka7DSJdZwYMAlwKR6K\n' +
    'BCfv8Qzjk83ay2SK82Kp1/acUxP9YSf752VQuv9XeK2q5+m+3bjqIiz3DqcKjfmA\n' +
    'RErhXvxXgDQ4O8MhK5uhr3wMhc356SqJ4VTbLvDE2XixNSuwJxCU3Xj+ThhHfVCv\n' +
    'Di0HaOZI+ktwKsqDr21kLefHQ+SIoJADFe2LhTJKs3qOHBkAcCb9g9eIFS1Bv4ha\n' +
    'CONlOROiigh8OjPdRjuxG/7jj8WrH6m/I5fhIiycW9Sinb22MMiTZEK/722SadkW\n' +
    'Gzygc1fB3FSODu7IHjqSU6h3uorB0T+awzqf4D6Yk+xk61YmNGaoPm5dA7Ttf8nU\n' +
    'x0SYVKxlol9FtyoSCiF/rQBjW8onMW84XMuRbzO9Mz9NVy9gHZvkXePRkWZGKcqg\n' +
    'JAwpdOnFIgu4vrNLFwIDAQABo1MwUTAdBgNVHQ4EFgQU1b1bypWuTbi+dNCFzSKk\n' +
    'iVc+MlAwHwYDVR0jBBgwFoAU1b1bypWuTbi+dNCFzSKkiVc+MlAwDwYDVR0TAQH/\n' +
    'BAUwAwEB/zANBgkqhkiG9w0BAQsFAAOCAgEAMJIPQzzFeauPNCpNAUaguJeCM0mg\n' +
    '+C+m8moycGBtR6eisSpviP4aDY13BdiB5Tx8y68NqL1kNY2AAP5vrjpXQgpMvTCo\n' +
    'BJxdXajWY1jqugGQCfFZwmQanGpKcpA0Be8y5Cod2IutlFQe6VTnvkFHoEKA5n3S\n' +
    'sveGLyP8KaqHPs3iDqE44A+ZO0/gipMYKphCxsExFsyC1SKDP8B2JfNFl9fVfNuL\n' +
    'tG3tuv622eLkPNqA7mHoqMZfpwBqNhx12byJbP6szF1X10cEPGtMLjSNTZaI7sM7\n' +
    'M3Dpe7cnQEBJnoyvwjKzoHN6hlmkd8EZ1f/7pWY1nn8kjfBFRYU+NTSHL7h7XfaD\n' +
    '4ldacLaHTe9DqzqVDw7jTjs9XGrmrIiJ/H/clpLX68cRwDRXc5C9TPTuNCJhCjtV\n' +
    'e+uiJwEpWGlEyRYqnpIy79XrAuWkeC+Buty3AAb0/b1eyedoj2iDV5IUdS5SrHq8\n' +
    '3Nbs1F0qhA67AOscL9AJrHrKshXzV7Mbvt5LClDxmTQUCA6utn5tx+wmLNzSsRMO\n' +
    '3iMVXNM6bPDF1Hw/cFSsoaQFnB5JgXsd/BiGqJc2ntsRm8UByH0M4foe6IAEAEp6\n' +
    'j6rW0Fe+ATryR70GIlg4Ncq3BiJy2KiNq2mOvETxjI+mowsRqxSd52HVExjBq4tn\n' +
    'cqDObFEpYyDFuxI=\n' +
    '-----END CERTIFICATE-----';
export default StaffPublicKey;